/**
 * /documents/:id — "Dokument ablegen": drop "prüfen", add "abgelegt", keep other tags, reload.
 */

const LUX_DOCUMENT_ABLEGEN_BTN_ID = 'luxDocumentConfirmBtn'

let luxAblegenStarted = false

function luxAblegenBeginVisit() {
  luxAblegenStarted = false
  document.getElementById(LUX_DOCUMENT_ABLEGEN_BTN_ID)?.remove()
}

function luxAblegenAuth() {
  try {
    return JSON.parse(localStorage.getItem('auth') || '{}').token || null
  } catch {
    return null
  }
}

async function luxAblegenJson(url, token, opts = {}) {
  const res = await fetch(url, {
    ...opts,
    headers: { Authorization: `Bearer ${token}`, Accept: 'application/json', ...opts.headers },
  })
  if (!res.ok) throw new Error(`${opts.method || 'GET'} ${res.status}`)
  const text = await res.text()
  return text ? JSON.parse(text) : null
}

function luxAblegenDoc(raw) {
  return Array.isArray(raw) ? raw[0] : raw
}

function luxAblegenHasTag(doc, name) {
  return (doc?.tags || []).some((tag) => tag.name === name)
}

function documentConfirmButton() {
  const documentId = window.location.pathname.split('/').filter(Boolean).pop() || ''
  if (!documentId) return

  const section = document.querySelector('#GeneralDocumentData')
  const header =
    section?.querySelector('.section-title') ||
    section?.querySelector('.section-title-box') ||
    section?.querySelector('.main-section-header, .section-header')
  const token = luxAblegenAuth()
  if (!header || !token || luxAblegenStarted || document.getElementById(LUX_DOCUMENT_ABLEGEN_BTN_ID)) return

  luxAblegenStarted = true
  luxAblegenJson(`/services/pmp-document/api/v1/documents/${documentId}`, token)
    .then((raw) => {
      const doc = luxAblegenDoc(raw)
      if (!luxAblegenHasTag(doc, 'prüfen') || luxAblegenHasTag(doc, 'abgelegt')) return
      if (document.getElementById(LUX_DOCUMENT_ABLEGEN_BTN_ID)) return

      Object.assign(header.style, {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        gap: '12px',
      })

      const button = document.createElement('button')
      button.type = 'button'
      button.id = LUX_DOCUMENT_ABLEGEN_BTN_ID
      button.className = 'ant-btn ant-btn-primary Button'
      button.textContent = 'Dokument ablegen'
      button.style.cssText = 'flex-shrink:0;margin-left:auto;background:#111;border-color:#111;color:#fff'
      const stop = (e) => {
        e.preventDefault()
        e.stopPropagation()
      }
      button.addEventListener('mousedown', stop)
      button.addEventListener('click', async (e) => {
        stop(e)
        button.disabled = true
        button.textContent = 'Wird abgelegt…'
        try {
          const fresh = luxAblegenDoc(
            await luxAblegenJson(`/services/pmp-document/api/v1/documents/${documentId}`, token),
          )
          if (!luxAblegenHasTag(fresh, 'prüfen')) {
            showToast('Das Dokument hat keinen Prüfen-Tag mehr.', 'warning')
            button.remove()
            return
          }
          const tagsRaw = await luxAblegenJson('/services/pmp-public/v2/document-tags?size=500', token)
          const abgelegtId = Number(
            (Array.isArray(tagsRaw) ? tagsRaw : tagsRaw.content || []).find((t) => t.name === 'abgelegt')?.id,
          )
          if (!abgelegtId) {
            showToast('Tag „abgelegt“ wurde nicht gefunden.', 'error')
            button.disabled = false
            button.textContent = 'Dokument ablegen'
            return
          }
          const tagIds = (fresh.tags || [])
            .filter((t) => t.name !== 'prüfen')
            .map((t) => Number(t.id))
            .filter(Number.isFinite)
          if (!tagIds.includes(abgelegtId)) tagIds.push(abgelegtId)

          await luxAblegenJson('/services/pmp-document/api/v1/documents', token, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify([{
              id: fresh.id,
              amount: fresh.amount,
              assignedTo: fresh.assignedTo,
              buildingId: fresh.buildingId,
              contactId: fresh.contactId,
              contractId: fresh.contractId,
              documentState: fresh.generationState,
              issuedDate: fresh.issuedDate,
              metaData: fresh.metaData,
              name: fresh.name,
              propertyId: fresh.propertyId,
              sourceId: fresh.sourceId,
              sourceType: fresh.sourceType,
              tagIds,
              unitId: fresh.unitId,
            }]),
          })
          window.location.reload()
        } catch (err) {
          console.error('[Lux] document ablegen failed', err)
          showToast('Dokument konnte nicht abgelegt werden.', 'error')
          button.disabled = false
          button.textContent = 'Dokument ablegen'
        }
      })
      header.appendChild(button)
    })
    .catch((err) => {
      luxAblegenStarted = false
      console.error('[Lux] document ablegen load failed', err)
    })
}
